import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Moment from 'moment'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Y from '../../../y18n'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import LanguagesDropdown from '../../../common/dropdowns/languages-dropdown'
import RolesDropdown from '../../../common/dropdowns/roles-dropdown'
import * as userActions from '../../../store/users'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  users: state.users,
  currentUser: state.accounts.profile
})

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch)
})

const roleValues = {
  'User': 0,
  'Admin': 1,
  'SuperAdmin': 2
}

class EditUserDialog extends Component {

  closeFormDialog = () => {
    this.props.userActions.resetActive()
  }

  inputChanged = name => event => {
    var update = true
    if(name === 'role'){
      if(this.props.users.active.id === this.props.currentUser.userId){
        if(roleValues[event.target.value] < roleValues[this.props.currentUser.role]){
          alert(Y`You've demoted yourself, if you proceed, you won't be able to promote yourself again!`)
        }else{
          alert(Y`You cannot promote yourself to a higher role!`)
          update = false
        }
      }else{
        if(roleValues[this.props.users.active.role] > roleValues[this.props.currentUser.role]){
          alert(Y`You cannot change the role of a user with a higher role than your own!`)
          update = false
        }
        else if(roleValues[event.target.value] > roleValues[this.props.currentUser.role]){
          alert(Y`You cannot promote a user to a role above your own!`)
          update = false
        }
      }
    }
    if(update)
      this.props.userActions.updateActive(name, event.target.value)
  }

  submitChanges = (e, user) => {
    e.preventDefault()
    this.props.userActions.editUser(user)
  }

  unblockUser = () => {
    this.props.userActions.unblockUser(this.props.users.active.id)
    this.props.userActions.resetActive()
    this.props.userActions.clearUsers()
    this.props.userActions.getUsers()
  }

  render () {
    const { classes, users, userActions } = this.props
    if (!users.active || users.new || users.history) return null

    return (
      <div>
        <Dialog
          open={users.active !== null}
          onClose={() => userActions.resetActive()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e, users.active)}>
            <DialogTitle>{Y`Edit user`}</DialogTitle>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Id`}
                type='text'
                value={users.active.id || ''}
                onChange={this.inputChanged('id')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                disabled
              />
              <div className={classes.flexRow}>
                <TextField
                  margin='normal'
                  label={Y`First name`}
                  type='text'
                  value={users.active.firstName || ''}
                  onChange={this.inputChanged('firstName')}
                  className={classes.flexItemLeft}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />
                <TextField
                  margin='normal'
                  label={Y`Last name`}
                  type='text'
                  value={users.active.lastName || ''}
                  onChange={this.inputChanged('lastName')}
                  className={classes.flexItemRight}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                />
              </div>
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Email`}
                type='email'
                value={users.active.email || ''}
                onChange={this.inputChanged('email')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Phone number`}
                type='phoneNumber'
                value={users.active.phoneNumber || ''}
                onChange={this.inputChanged('phoneNumber')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
            </DialogContent>
            <DialogContent>
              <div className={classes.flexRow}>
                <TextField
                  margin='normal'
                  label={Y`Address`}
                  type='text'
                  value={users.active.address || ''}
                  onChange={this.inputChanged('address')}
                  className={classes.flexItemLeft}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
                <TextField
                  margin='normal'
                  label={Y`Zip code`}
                  type='text'
                  value={users.active.zipCode || ''}
                  onChange={this.inputChanged('zipCode')}
                  className={classes.flexItemMiddle}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
                <TextField
                  margin='normal'
                  label={Y`City`}
                  type='text'
                  value={users.active.city || ''}
                  onChange={this.inputChanged('city')}
                  className={classes.flexItemRight}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
              </div>
            </DialogContent>
            <DialogContent>
              <div className={classes.flexRow}>
                <div className={classes.flexItemLeft}>
                  <CountriesDropdown handleChange={this.inputChanged('country')} value={users.active.country || ''} />
                </div>
                <div className={classes.flexItemMiddle}>
                  <LanguagesDropdown handleChange={this.inputChanged('language')} value={users.active.language || ''} />
                </div>
                <div className={classes.flexItemRight}>
                  <RolesDropdown handleChange={this.inputChanged('role')} value={users.active.role || ''} />
                </div>
              </div>
            </DialogContent>
            {users.active.blocked &&
              Moment.utc(users.active.unblockTime).local().isAfter(Moment()) &&
              <DialogContent>
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <Typography variant='body2' style={{ color: 'red' }}>
                    {Y`User is blocked because of too many failed login attempts. User will be unblocked`}
                    {' '}
                    {Moment.utc(users.active.unblockTime).local().format('YYYY-MM-DD HH:mm:SS')}
                    {' '}
                  </Typography>
                </div>
              </DialogContent>}
            <DialogActions>
              <Button onClick={() => userActions.resetActive()} style={{ marginRight: '10px' }}>{Y`Cancel`}</Button>
              {users.active.blocked &&
                Moment.utc(users.active.unblockTime).local().isAfter(Moment()) &&
                <Button
                  onClick={() => this.unblockUser()}
                  style={{ marginRight: '10px', color: 'red' }}
                >{Y`Unblock`}</Button>}
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

EditUserDialog = connect(mapStateToProps, mapDispatchToProps)(EditUserDialog)
export default withStyles(Styles)(EditUserDialog)



// WEBPACK FOOTER //
// ./src/pages/users/containers/edit-user-dialog.js